import { ICON__list_check, ICON__list_x } from '@/assets/icons_lucide';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { use_slice_generation, use_slice_ui } from '@/hooks/store/use_slices';
import { PLACEHOLDER_BUTTON__bar } from '@/pages/_base/buttons/PLACEHOLDER_BUTTON__bar';
import { UTILS__graph_data } from '@/utils/UTILS__graph_data';
import { DTO__ml_asset } from '@shared/dto/+model/sd/ml_asset/DTO__ml_asset';
import { FIELD__list_token } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_token';
import { ENUM__token_type } from '@shared/dto/generation/graph_invoke/_fields/token/ENUM__token_type';
import { useMemo } from 'react';

interface PROPS {
  field: FIELD__list_token;
  ml_asset_list: DTO__ml_asset[];
  is_positive: boolean;
}

export function G_UI_FIELD__token_list_embedding__button_select_all({ field, ml_asset_list, is_positive }: PROPS) {
  /*
   *
   */

  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);
  const { generation_current } = use_slice_generation(['generation_current']);

  /*
   *
   */

  let embeddings = field.items.filter(item => item.type == ENUM__token_type.EMBEDDING);

  let embeddings_in_field__hashes_set = new Set(embeddings.map(item => item.word_english.get_value()));

  let embeddings_in_list__hashes_set = new Set(ml_asset_list.map(item => item.hash_sha256));

  const are_all_items_selected = useMemo(() => get_are_all_items_selected(), [field]);

  /*
   *
   */

  async function onClick(e: React.MouseEvent) {
    e.stopPropagation();

    let field_new = field.clone();

    are_all_items_selected ? embeddings_remove(field_new) : embeddings_add(field_new);

    field_new.field_name_and_path__fill_for_children();

    /*
     *
     */

    await UTILS__graph_data.update_field(generation_current.tool.graph, field_new);
  }
  /*
   *
   */

  /*
   *
   */
  function embeddings_remove(field_new: FIELD__list_token) {
    let items = [...field_new.items];

    for (let token of items) {
      if (token.type != ENUM__token_type.EMBEDDING) continue; //do nothing
      if (!embeddings_in_list__hashes_set.has(token.word_english.get_value())) continue; //no need to make action

      field_new.item_remove(token);
    }
  }

  function embeddings_add(field_new: FIELD__list_token) {
    for (let ml_asset of ml_asset_list) {
      if (embeddings_in_field__hashes_set.has(ml_asset.hash_sha256)) continue; //already added

      let token = field_new.create_item_new();
      token.type = ENUM__token_type.EMBEDDING;

      token.is_positive.set_value(is_positive);
      token.word_english.set_value(ml_asset.hash_sha256);
    }
  }

  function get_are_all_items_selected() {
    let is_every_selected = ml_asset_list.every(item => embeddings_in_field__hashes_set.has(item.hash_sha256));

    return is_every_selected;
  }

  function is_disabled() {
    return g_general__ui_disabled;
  }

  /*
   *
   */

  if (ml_asset_list.is_empty()) return <PLACEHOLDER_BUTTON__bar />;

  return (
    <UI_PRIMITIVE__button_with_icon_animated
      size="3-full"
      variant="no-border-on-bar"
      iconClassNameBase="!text-component-item-foreground size-3"
      iconClassNameHovered="!text-bar-foreground"
      {...{ onClick }}
      disabled={is_disabled()}
      renderDelay={CONSTANTS_TIME__client.TIMEOUT_DELAY_BEFORE_FIRST_ANIMATION_RENDER}
      Icon={are_all_items_selected ? ICON__list_x : ICON__list_check}
    />
  );
}
